module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "nome",
      "required": "",
      "label": "Nome"
    },
    model: {
      value: (_vm.usuario.nome),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "nome", $$v)
      },
      expression: "usuario.nome"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "email",
      "required": "",
      "label": "E-mail"
    },
    model: {
      value: (_vm.usuario.email),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "email", $$v)
      },
      expression: "usuario.email"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "username",
      "required": "",
      "label": "Login"
    },
    model: {
      value: (_vm.usuario.username),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "username", $$v)
      },
      expression: "usuario.username"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "password",
      "label": "Senha",
      "append-icon": _vm.mostrarSenha ? 'visibility' : 'visibility_off',
      "append-icon-cb": function () { return (_vm.mostrarSenha = !_vm.mostrarSenha); },
      "type": _vm.mostrarSenha ? 'password' : 'text'
    },
    model: {
      value: (_vm.usuario.password),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "password", $$v)
      },
      expression: "usuario.password"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-select', {
    attrs: {
      "required": "",
      "chips": "",
      "label": "Permissões",
      "items": _vm.itemsPermissoes,
      "item-text": "authority",
      "item-value": "id",
      "multiple": "",
      "max-height": "400",
      "hint": "Selecione as permissões",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.usuario.authorities),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "authorities", $$v)
      },
      expression: "usuario.authorities"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "cpf",
      "label": "CPF"
    },
    model: {
      value: (_vm.usuario.cpf),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "cpf", $$v)
      },
      expression: "usuario.cpf"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "crm",
      "label": "CRM"
    },
    model: {
      value: (_vm.usuario.crm),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "crm", $$v)
      },
      expression: "usuario.crm"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "crmUf",
      "label": "UF CRM"
    },
    model: {
      value: (_vm.usuario.crmUf),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "crmUf", $$v)
      },
      expression: "usuario.crmUf"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm2": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Ativo",
      "color": "primary"
    },
    model: {
      value: (_vm.usuario.enabled),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "enabled", $$v)
      },
      expression: "usuario.enabled"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm2": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Bloqueado",
      "color": "primary"
    },
    model: {
      value: (_vm.usuario.accountLocked),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "accountLocked", $$v)
      },
      expression: "usuario.accountLocked"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm2": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Conta Expirada",
      "color": "primary"
    },
    model: {
      value: (_vm.usuario.accountExpired),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "accountExpired", $$v)
      },
      expression: "usuario.accountExpired"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm2": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Senha Expirada",
      "color": "primary"
    },
    model: {
      value: (_vm.usuario.passwordExpired),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "passwordExpired", $$v)
      },
      expression: "usuario.passwordExpired"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "chips": "",
      "label": "Empresas",
      "items": _vm.empresas,
      "item-text": "nome",
      "item-value": "id",
      "multiple": "",
      "max-height": "400",
      "hint": "Selecione as empresas",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.usuario.empresas),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "empresas", $$v)
      },
      expression: "usuario.empresas"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "chips": "",
      "label": "Unidades",
      "items": _vm.unidades,
      "item-text": "nome",
      "item-value": "id",
      "multiple": "",
      "max-height": "400",
      "hint": "Selecione as unidades",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.usuario.unidades),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "unidades", $$v)
      },
      expression: "usuario.unidades"
    }
  })], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": _vm.timeoutAlerta,
      "color": _vm.tipoAlerta
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.textAlerta) + "\n      "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("Fechar")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08c58dee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UsuarioForm.vue
// module id = 357
// module chunks = 1